import ClientSideValidation from '@assets/components/clientSideValidation';

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
export function validateForm(event) {
    let valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select, textarea').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
    }
    return valid;
}

export function clearElement(element) {
    $(element).removeClass('is-invalid');
}

export function validateElement(event) {
    const { valid } = this.validity;
    if (!valid) {
        // safari
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).trigger('invalid', this.validity);
    } else {
        clearElement(this);
    }
    return valid;
}

/**
 * Listener for invalid event
 * @param {string} selector - Selector for elements to listen for invalid event
 */
export function invalidListener(selector) {
    $(selector).on('invalid', function (e) {
        e.preventDefault();
        this.setCustomValidity('');
        if (!this.validity.valid) {
            let { validationMessage } = this;
            $(this).addClass('is-invalid');
            if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                validationMessage = $(this).data('pattern-mismatch');
            }
            if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                && $(this).data('range-error')) {
                validationMessage = $(this).data('range-error');
            }
            if ((this.validity.tooLong || this.validity.tooShort)
                && $(this).data('range-error')) {
                validationMessage = $(this).data('range-error');
            }
            if (this.validity.valueMissing && $(this).data('missing-error')) {
                validationMessage = $(this).data('missing-error');
            }
            $(this).parents('.form-group').find('.invalid-feedback')
                .text(validationMessage);
        }
    });
}

export default class extends ClientSideValidation {
    constructor() {
        super();
        this.functions.validateElement = validateElement;
        this.functions.clearElement = clearElement;
    }

    init() {
        super.init();
    }

    invalid() {
        invalidListener('form input, form select, form textarea');
    }
}
